import { render, staticRenderFns, recyclableRender, components } from "./z-paging-empty-view.vue?vue&type=template&id=a664708e&scoped=true&"
var renderjs
import script from "./z-paging-empty-view.vue?vue&type=script&lang=js&"
export * from "./z-paging-empty-view.vue?vue&type=script&lang=js&"
import style0 from "./z-paging-empty-view.vue?vue&type=style&index=0&id=a664708e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a664708e",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/z-paging/components/z-paging-empty-view/z-paging-empty-view.vue"
export default component.exports